module.exports = __webpack_public_path__ + "img/img01@2x.c7dd79ff.webp";